import { render, staticRenderFns } from "./image_dialog.vue?vue&type=template&id=3b104f0c&"
import script from "./image_dialog.vue?vue&type=script&lang=js&"
export * from "./image_dialog.vue?vue&type=script&lang=js&"
import style0 from "./image_dialog.vue?vue&type=style&index=0&id=3b104f0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports